import mutations from "./mutations";
import getters from "./getters";
import { DataService, client } from "../../../config/dataService/dataService";
import { useMessage } from "../../../composables";

const { successMessage, errorMessage } = useMessage();

const state = () => ({
  loading: false,
  error: null,
  statusCode: 0,
  admins: [],
  allSkills: {
    items: [],
    count: 0,
  },
  allAdmins: {
    items: [],
    count: 0,
  },
  allJobs: {
    items: [],
    count: 0,
  },
  adminById: {},
  message: "",
  companies: [],
  educations: [],
  company: {
    data: [],
    count: 0,
  },
  allInsights: {
    items: [],
    count: 0,
  },
  allCandidateJobApplied: {
    items: [],
    count: 0,
  },
  pendingUsers: {
    items: [],
    count: 0,
  },
});

const actions = {
  async getAllSkills({ commit }, { page, itemPerPage, filters = {} }) {
    try {
      const res = await DataService.post("admin/skill/list", {
        filters,
        pagination: {
          field: "id",
          ascending: true,
          page: page,
          items_per_page: itemPerPage,
        },
      });
      commit("SET_ALL_SKILLS", res.data);
    } catch (error) {
      console.error(error);
    }
  },
  async allAdmins({ commit }, payload) {
    try {
      const res = await DataService.post("admin/users/list", payload);
      commit("SET_ALL_ADMINS", res.data);
    } catch (error) {
      console.error(error);
    }
  },

  async getAllAdmins({ commit }, payload) {
    try {
      const res = await DataService.post("admin/users/list", payload);
      commit("SET_ALL_ADMINS", res.data);
    } catch (error) {
      console.error(error);
    }
  },

  async getSingleAdmin(contex, id) {
    let response = {};
    try {
      const res = await DataService.get(`admin/users/${id}`);
      response.admin = { ...res.data };
    } catch (error) {
      response.admin = null;
    }

    return response;
  },
  async getAdmins({ commit }) {
    try {
      let res = await DataService.get("admin/users/").then((res) => res);

      commit("SET_ADMINS", res.data);
    } catch (err) {
      return err;
    }
  },

  async updateAppTrackStatus(context, data) {
    let url = data.path
      ? "/admin/job-apply/bulk-statuses"
      : "/company/bulk-statuses";

    try {
      let res = await DataService.post(url, data);
      res?.status === 200
        ? successMessage("Succesfully updated status.")
        : errorMessage("Something went wrong.");

      return res;
    } catch (err) {
      errorMessage("Something went wrong.");
      return err;
    }
  },

  async deleteAdmin(contex, id) {
    try {
      let adminID = id.toString();
      let res = await DataService.delete(`admin/users/${adminID}/`);
      successMessage("User deleted successfully");

      return res;
    } catch (error) {
      errorMessage("Something went wrong");
    }
  },
  createAdmin(contex, data) {
    try {
      let res = DataService.post(`admin/users/`, data).then((res) => res);

      return res;
    } catch (err) {
      console.error(err);
    }
  },

  async updateAdmin({ commit }, data) {
    try {
      const res = await DataService.put(`admin/users/${data.id}/`, {
        username: data.username,
        id: data.id,
        password: data.password,
        role: data.role,
        active: data.active,
      });

      if (res.status === 200) {
        commit("UPDATE_ADMIN", res.data);
        successMessage(
          `${data.role.charAt(0).toUpperCase()}${data.role.slice(
            1
          )} updated succesfully`
        );
      }
      return res;
    } catch (error) {
      errorMessage("Something went wrong");
      return error;
    }
  },

  async isRegistrable(context, data) {
    try {
      let res = await DataService.post("/public/candidate/registerable", {
        username: data.username,
        password: data.password,
        role: "user",
      }).then((res) => res);
      return res;
    } catch (err) {
      return err;
    }
  },
  // Companies
  async createCompany(contex, data) {
    console.log("data service", data.service);
    try {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("logo", data.logo[0].originFileObj);
      formData.append("year", data.year);
      formData.append("contact_email", data.contact_email);
      formData.append("industry", data.industry);
      formData.append("sector", data.sector);
      formData.append("services", JSON.stringify(data.service));
      formData.append("employee_range", data.employee_range);
      formData.append("number_of_emplyees", data.number_of_emplyees);
      let res = await client.post("admin/company/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (err) {
      errorMessage("Something went wrong");
      return err;
    }
  },
  async getCompanies({ commit }) {
    try {
      let res = await DataService.get(`public/companies`).then((res) => res);
      commit("SET_GET_COMPANIES", res.data.data);
      return res;
    } catch (err) {
      return err;
    }
  },

  async getAllCompanies({ commit }, { page, itemPerPage, filters = {} }) {
    try {
      const res = await DataService.post("admin/company/list", {
        filters: filters,
        pagination: {
          field: "id",
          ascending: true,
          page: page,
          items_per_page: itemPerPage,
        },
      });
      commit("SET__ALL__COMPANIES", res.data);
    } catch (error) {
      console.error(error);
    }
  },

  async updateCompany({ commit }, data) {
    console.log(data);
    try {
      const formData = new FormData();

      formData.append("name", data.name);
      formData.append("logo", data.logo ? data.logo[0].originFileObj : "");
      formData.append("year", data.year);
      formData.append("contact_email", data.contact_email);
      formData.append("industry", data.industry);
      formData.append("sector", data.sector);
      formData.append("services", JSON.stringify(data.service));
      formData.append("employee_range", data.employee_range);
      formData.append("number_of_emplyees", data.number_of_emplyees);
      let res = await client.put(`admin/company/${data.id}/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.status === 200) {
        successMessage("Succesfully updated company.");
        commit("UPDATE_COMPANY", res.data);
      }
      return res;
    } catch (err) {
      return err;
    }
  },

  async deleteCompany(contex, id) {
    try {
      let companyId = id.toString();
      let res = await DataService.delete(`/admin/company/${companyId}/`);
      return res;
    } catch (err) {
      return err;
    }
  },
  //skills

  async updateSkill(context, skill) {
    try {
      let res = await DataService.put(`/admin/skill/${skill.id}/`, {
        name: skill.name,
        skill_type: skill.skill_type,
      });
      successMessage("Succesfully updated skill");
      return res;
    } catch (err) {
      return err;
    }
  },

  async createSkill(contex, data) {
    try {
      let res = await DataService.post(`/admin/skill/`, data).then(
        (res) => res
      );
      return res;
    } catch (err) {
      return err;
    }
  },

  async deleteSkill(contex, id) {
    let skillID = id.toString();

    let res = await DataService.delete(`admin/skill/${skillID}/`);
    return res;
  },
  //institution
  async getInstitutionById(context, id) {
    let instId = id.toString();

    try {
      let res = await DataService.get(`admin/institution/${instId}/`).then(
        (res) => res
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  // educations
  async createEducation(contex, data) {
    try {
      let res = await DataService.post(`/admin/education/`, {
        candidate: Number(data.candidate),
        institution: data.institution,
        degree: data.degree,
        field_of_study: data.field_of_study,
        year_start: Number(data.year_start),
        year_end: Number(data.year_end),
      }).then((res) => res);
      return res;
    } catch (err) {
      return err;
    }
  },
  async getEducations({ commit }) {
    try {
      let res = await DataService.get("admin/education/").then((res) => res);
      commit("SET_GET_EDUCATIONS", res.data);
    } catch (error) {
      return error;
    }
  },

  async updateEducation(context, data) {
    try {
      let res = await DataService.put(`/admin/education/${data.id}/`, {
        candidate: data.name,
        institution: data.institution,
        degree: data.degree,
        field_of_study: data.field_of_study,
        year_start: data.year_start,
        year_end: data.year_start,
      }).then((res) => res);
      return res;
    } catch (err) {
      return err;
    }
  },

  async deleteEducation(contex, id) {
    let eduId = id.toString();
    let res = await DataService.delete(`admin/education/${eduId}`);
    return res;
  },

  //Job post
  async getJobPosts({ commit }, { page, itemPerPage, filters = {} }) {
    try {
      const res = await DataService.post("admin/job-post/list", {
        filters,
        pagination: {
          field: "id",
          ascending: true,
          page,
          items_per_page: itemPerPage,
        },
      });
      commit("SET_ALL_JOBS", res.data);
    } catch (error) {
      return error;
    }
  },

  async getSingleJobPost(contex, id) {
    let response = {};
    try {
      const res = await DataService.get(`admin/job-post/${id}/`);
      response.jobPost = { ...res.data };
    } catch (error) {
      response.jobPost = null;
    }

    return response;
  },
  async createJobPost(context, data) {
    try {
      const res = await DataService.post("admin/job-post/", {
        company: Number(data.company),
        title: data.title,
        deadline: data.deadline,
        description: data.description,
        tasks: data.tasks === null ? "" : data.tasks,
        city: data.city,
        active: data.active,
        job_post_category: data.job_post_category,
        skills: data.skills,
        industry: data.industry,
        about_company: data.about_company,
        contact_at: data.contact_at,
        job_benefits: data.job_benefits,
        job_function: data.job_function,
        number_of_opening: data.number_of_opening,
        opening_date: data.opening_date,
        salary: data.salary,
        sector: data.sector,
        target_start_date: data.target_start_date,
      });
      return res;
    } catch (err) {
      return err;
    }
  },

  async deleteJobPost(contex, id) {
    try {
      let jobPostId = id.toString();
      let res = await DataService.delete(`/admin/job-post/${jobPostId}/`);
      successMessage("Job post deleted successfully");
      return res;
    } catch (err) {
      errorMessage("Somthing went wrong");
      return err;
    }
  },

  async updateJobPost({ commit }, data) {
    try {
      let res = await DataService.put(`/admin/job-post/${data.id}/`, {
        company: data.company,
        title: data.title,
        deadline: data.deadline,
        description: data.description,
        tasks: data.tasks,
        city: data.city,
        active: data.active,
        job_post_category: data.job_post_category,
        industry: data.industry,
        about_company: data.about_company,
        contact_at: data.contact_at,
        job_benefits: data.job_benefits,
        job_function: data.job_function,
        number_of_opening: data.number_of_opening,
        opening_date: data.opening_date,
        salary: data.salary,
        sector: data.sector,
        target_start_date: data.target_start_date,
        skills: data.skills,
      });
      if (res?.status === 200) {
        successMessage("Job status has been updated");
        commit("UPDATE_JOBPOST", data);
      }
      return res;
    } catch (err) {
      errorMessage("Something went wrong");

      return err;
    }
  },

  //insights
  async getAllInsights({ commit }, { page, itemPerPage, filters = {} }) {
    try {
      const res = await DataService.post("admin/insights/list", {
        filters,
        pagination: {
          field: "id",
          ascending: true,
          page: page,
          items_per_page: itemPerPage,
        },
      });
      commit("SET_ALL_INSIGHTS", res.data);
    } catch (error) {
      console.error(error);
    }
  },
  async createInsight(context, data) {
    try {
      let res = await DataService.post("admin/insights/", {
        company: Number(data.company),
        rank_in_industry: Number(data.rank_in_industry),
        turnover_rate_year_1: Number(data.turnover_rate_year_1),
        turnover_rate_year_2: Number(data.turnover_rate_year_2),
        turnover_rate_year_3: Number(data.turnover_rate_year_3),
        rank_in_industry_year_1: Number(data.rank_in_industry_year_1),
        rank_in_industry_year_2: Number(data.rank_in_industry_year_1),
        rank_in_industry_year_3: Number(data.rank_in_industry_year_1),
        rank_in_sector_year_1: Number(data.rank_in_sector_year_1),
        rank_in_sector_year_2: Number(data.rank_in_sector_year_2),
        rank_in_sector_year_3: Number(data.rank_in_sector_year_3),
      });

      if (res.status === 409) {
        errorMessage(res?.data?.detail || 'Something went wrong');
      }

      if (res.status === 200) {
        successMessage("Succesfully created insight.");
        return true
      }
    } catch (error) {
      errorMessage(error?.response?.data?.detail || 'Something went wrong');
      return false;
    }
  },
  async updateInsight(context, data) {
    try {
      let res = await DataService.put(`/admin/insights/${data.id}/`, {
        company: Number(data.company),
        rank_in_industry: Number(data.rank_in_industry),
        turnover_rate_year_1: Number(data.turnover_rate_year_1),
        turnover_rate_year_2: Number(data.turnover_rate_year_2),
        turnover_rate_year_3: Number(data.turnover_rate_year_3),
        rank_in_industry_year_1: Number(data.rank_in_industry_year_1),
        rank_in_industry_year_2: Number(data.rank_in_industry_year_1),
        rank_in_industry_year_3: Number(data.rank_in_industry_year_1),
        rank_in_sector_year_1: Number(data.rank_in_sector_year_1),
        rank_in_sector_year_2: Number(data.rank_in_sector_year_2),
        rank_in_sector_year_3: Number(data.rank_in_sector_year_3),
      });

      if (res.status === 200) {
        successMessage("Succesfully updated insight.");
        return true
      }
    } catch (err) {
      errorMessage(err?.response?.data?.detail || 'Something went wrong');
    }
  },
  async getSingleInsight(contex, id) {
    let response = {};
    try {
      const res = await DataService.get(`admin/insights/${id}`);

      response.insightPost = { ...res.data };
    } catch (error) {
      response.insightPost = null;
    }

    return response;
  },

  async deleteInsight(contex, id) {
    try {
      let insightId = id.toString();
      let res = await DataService.delete(`admin/insights/${insightId}/`);
      successMessage("Insight deleted successfully");

      return res;
    } catch (error) {
      errorMessage("Something went wrong");
    }
  },

  async getCandidateAppliedJobs({ commit }, { page, itemPerPage, filters }) {
    try {
      const res = await DataService.post("admin/job-apply/list/", {
        filters: filters,
        pagination: {
          field: "id",
          ascending: true,
          page: page,
          items_per_page: itemPerPage,
        },
      });

      commit("SET_CANDIDATE_APPLIED_JOBS", res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error;
    }
  },
  async getCandidateByID(context, id) {
    let response = {};
    try {
      const res = await DataService.get(`admin/candidate/${id}`);
      response.candidateData = { ...res.data };
    } catch (error) {
      response.candidateData = null;
    }

    return response;
  },

  async getPendingUsers({ commit }) {
    try {
      const res = await DataService.get("admin/users/pending");
      commit("SET_PENDING_USERS", res?.data);
      return res;
    } catch (error) {
      console.error(error);
    }
  },
  async getSingleEdit(contex, data) {
    let response = {};
    try {
      const res = await DataService.get(`admin/${data.sector}/${data.id}`);
      response.data = { ...res.data };
    } catch (error) {
      response.data = null;
    }

    return response;
  },
};

export default {
  namespaced: false,
  state,
  actions,
  mutations,
  getters,
};
